import React, { useState } from "react";
import CartToggleComponent from "../components/CartToggleComponent";

import HeaderSearch from "../components/HeaderSearch";

const MobileFooter =({ data ,getOpen, setOpen}) => {
  const [activeNavItem, setActiveNavItem] = useState(null);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const handleItemClick = (el, clr) => {
    setActiveNavItem(el);
    //document.body.style.setProperty("--activeclr", clr);
    setIsSearchActive(false); // Close search when an item is clicked
  };

  const searchVisibility = () => {
    setIsSearchActive(!isSearchActive);
   
  };
  const toggle = (e) => {
    e.preventDefault();
    setOpen(!getOpen);
    
  };

  return (
    <>
   
    <div className="mobile-navbar mob-d-active">
      <div className="navbar">
      {/* <SideMenu data={data}/> */}
      <a
          href="/"
          className={`mob-d-active navitem`}
          onClick={toggle}
          data-clr="#fff6cc"
        >
          <div className="indicator"></div>
          <div className="hoverindicator"></div>
          <i className='charm--apps'></i>
        </a>
        <div className="navsearch">
          
          <div className="searchicon" onClick={searchVisibility}>
          <i className='bi--search'></i>
          </div>
          {/* <div className={`overlay ${isSearchActive ? 'show' : ''}`} onClick={searchVisibility}></div> */}
         

        </div>
        {/* <a
          href="#"
          className={ `cart__btn order-1 navitem${activeNavItem === "home" ? " active" : ""}`}
          onClick={() => handleItemClick("home", "#e4ecfa")}
          data-clr="#e4ecfa"
        >
          <div className="indicator"></div>
          <div className="hoverindicator"></div>
          <i className='f7--cart-fill'></i>
          <span class="noti_count2">0</span>
        </a> */}
         <CartToggleComponent />
        
        <a
          href="#"
          className={`contact navitem`}
          onClick={() => handleItemClick("cog", "#f0e4fa")}
          data-clr="#f0e4fa"
        >
          <div className="indicator"></div>
          <div className="hoverindicator"></div>
         
          <input id="menu" type="checkbox" />
            <label for="menu"><i class="f7--phone-fill"></i></label>
            <ul class="mobile-contact">
             
              <li>
                <a href="tel:+97180032986329" className="phone-call-loop">
                  {/* <span>Contact</span> */}
                  <i class="line-md--phone-call-loop "></i>
                </a>
              </li>
              <li>
               
                 
                  <a href="https://wa.me/+97142612111" className="whatsapp" target="_blank">
                  {/* <span>WhatsApp</span> */}
                  <i class="bi--whatsapp"></i>

                    </a>
               
              </li>
              <li>
                <a href="https://www.instagram.com/daytodayhypermarket" target="_blank">
                
                  <i class="line-md--instagram"></i>
                </a>
              </li>
              {/* <li>
                <a href="#0">
                  <span>Clients</span>
                  <i class="ri-team-line"></i>
                </a>
              </li> */}
              
            </ul>
        
        </a>
       
      </div>
    </div>
     <div className={`animatedDiv ${isSearchActive ? 'show' : ''}`}>
     <HeaderSearch className='search-sm w-100' setIsSearchActive={setIsSearchActive} />
     </div>
     </>
  );
};

export default MobileFooter;
